<template>
  <div id="wrapper" class="page">
    <qtake-side-bar index="2" />
    <div id="content-wrapper">
      <div class="container-fluid">
        <button class="btn btn-info mb-2" @click.prevent="openQtakeModal" v-if="qtake_department_create">
          <i class="fas fa-plus"></i> Add a Company
        </button>
        <b-table
          bordered
          head-variant="dark"
          hover
          responsive
          striped
          small
          table-variant="light"
          :fields="qtake_departmentFields"
          :items="qtake_departmentItems"
        >
          <template v-slot:cell(use)="data">
            <template v-if="data.item.use">
              <span aria-hidden="true">&check;</span>
              <span class="sr-only">Selected</span>
            </template>
            <template v-else>
              <span aria-hidden="true">&nbsp;</span>
              <span class="sr-only">Not selected</span>
            </template>
          </template>
          <template v-slot:cell(color)="data">
            <div v-bind:style="{ 'background-color': data.value}" style="width: 42px; height: 42px;border-radius: 10px;"></div>
          </template>
          <template v-slot:cell(action)="data">
            <b-link class="text-primary mr-2" href="#" @click.prevent="openQtakeUpdateModal(data)" v-if="qtake_department_update">
                <i class="fas fa-pencil-alt"></i>
            </b-link>
            <b-link class="text-danger" href="#" @click.prevent="deleteQtakeDepartment(data)" v-if="qtake_department_delete">
                <i class="fas fa-trash"></i>
            </b-link>
          </template>
        </b-table>
      </div>
    </div>

    <!-- QTAKE MODAL -->
    <b-modal
      v-model="qtakeModalShow"
      @ok="storeQtakeDepartment"
      @cancel="closeQtakeModal"
      @hidden="closeQtakeModal"
      header-bg-variant="info"
      header-text-variant="light"
    >
      <template v-slot:modal-title>
        <div v-if="qtake_department.id <= 0">Add a Company</div>
        <div v-else>Update a Company</div>
      </template>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="info" @click="ok()"><i class="fas fa-save mr-2"></i>Save</b-button>
        <b-button variant="secondary" @click="cancel()"><i class="fas fa-times mr-2"></i>Cancel</b-button>
      </template>
      <b-container>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>Company (full Name)
                <span class="text-danger">*</span>
              </template>
              <b-form-input v-model="qtake_department.fullname" autocomplete="false" required />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>Company (short name)
                <span class="text-danger">*</span>
              </template>
              <b-form-input v-model="qtake_department.name" autocomplete="false" required />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <b-form-checkbox v-model="qtake_department.isinternal">Internal</b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>Color
                <span class="text-danger">*</span>
              </template>
              <v-swatches v-model="qtake_department.color" swatches="text-advanced" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>Address</template>
              <b-form-input v-model="qtake_department.address"/>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>Notes</template>
              <b-form-input v-model="qtake_department.notes" required/>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="4">
            <b-form-group>
              <b-form-checkbox v-model="qtake_department.use">In use</b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col cols="7">
            <b-form-group>
              <b-form-checkbox v-model="qtake_department.multibooking">Multiple booking</b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
    <!-- END OF QTAKE MODAL -->
  </div>
</template>

<script>
import axios from "axios";
import QtakeSideBar from "../components/Qtake/QtakeSideBar";
import VSwatches from "vue-swatches";
import "vue-swatches/dist/vue-swatches.css";

export default {
  name: "QtakeDepartments",
  components: {
    QtakeSideBar,
    VSwatches,
  },
  data() {
    return {
      qtake_departmentFields: [
        {
          key: "name",
          label: "Name",
        },
        {
          key: "color",
          label: "Color",
        },
        {
          key: "notes",
          label: "Note",
        },
        {
          key: "use",
          label: "Usage",
        },
        {
          key: "action",
          label: "",
          thStyle: { width: "50px !important" },
        },
      ],
      qtake_departmentItems: [],
      qtakeModalShow: false,
      qtake_department: {
        id: 0,
        name: null,
        fullname: null,
        address: "",
        isinternal: true,
        use: true,
        notes: null,
        color: null,
        multibooking: true,
      },
      qtake_department_flush: null,
      itemIndex: null,
    }
  },
  computed: {
    qtake_department_create() {
      //return this.$store.getters.hasPermission("meeting_create");
      return true;
    },
    qtake_department_update() {
      //return this.$store.getters.hasPermission("meeting_update");
      return true;
    },
    qtake_department_delete() {
      //return this.$store.getters.hasPermission("meeting_delete");
      return true;
    },
  },
  beforeRouteEnter(to, from, next) {
    axios.get("/api/qtakedepartment")
      .then((response) => {next((vm) => vm.initData(response.data));})
      .catch((err) => {next();});
  },
  methods: {
    initData(qtake_departments) {
      this.qtake_departmentItems = qtake_departments;
      this.qtake_department_flush = this.$copy(this.qtake_department);
    },
    openQtakeModal() {
      this.qtakeModalShow = true;
    },
    openQtakeUpdateModal(data) {
      this.qtake_department = JSON.parse(JSON.stringify(data.item));
      this.itemIndex = data.index;
      this.qtakeModalShow = true;
    },
    closeQtakeModal() {
      this.qtake_department = this.$copy(this.qtake_department_flush);
      this.itemIndex = null;
      this.qtakeModalShow = false;
    },
    storeQtakeDepartment(bvModalEvt) {
      if (!(this.qtake_department.name && this.qtake_department.name.length) || !(this.qtake_department.color && this.qtake_department.color.length)) {
        this.$toast.error("Vui lòng nhập đầy đủ thông tin", "Lỗi", {timeout: 2000});
        bvModalEvt.preventDefault();
        return;
      }

      if (this.qtake_department.id <= 0) { this.addQtakeDepartment();    return;}
      if (this.qtake_department.id  > 0) { this.updateQtakeDepartment(); return;}
    },
    addQtakeDepartment() {
      const is_item_exist = this.qtake_departmentItems.filter(x => x.name.toLowerCase() === this.qtake_department.name.toLowerCase());
      if (is_item_exist.length > 0) {
        this.$toast.error("Tên đã tồn tại !", "Lỗi", { timeout: 2000 });
        return;
      }

      axios.post("/api/qtakedepartment", this.qtake_department)
      .then((res) => {
        this.closeQtakeModal();
        this.qtake_departmentItems.push(res.data);
        this.$toast.success("Tạo thành công !", "Thành công", {timeout: 3000,});
      })
      .catch((err) => {this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });});
       },
    updateQtakeDepartment() {
      const is_item_exist = this.qtake_departmentItems.filter(x => x.name.toLowerCase() === this.qtake_department.name.toLowerCase() && x.id !== this.qtake_department.id);

      if (is_item_exist.length > 0) {
        this.$toast.error("Tên đã tồn tại !", "Lỗi", { timeout: 2000 });
        return;
      }

      axios.put("/api/qtakedepartment", this.qtake_department)
      .then((res) => {
        // this.qtake_departmentItems[this.itemIndex] = JSON.parse(JSON.stringify(this.qtake_department));
        // const temp = JSON.parse(JSON.stringify(this.qtake_departmentItems));
        // this.qtake_departmentItems = JSON.parse(JSON.stringify(temp));

        this.qtake_departmentItems = this.$insert_array_parse_json(this.qtake_department, this.qtake_departmentItems);
        this.$toast.success("Cập nhật thành công thành công !", "Thành công", {timeout: 3000,});
        this.closeQtakeModal();
      })
      .catch((err) => {this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });});
    },
    deleteQtakeDepartment(data) {
      this.$toast.question("Do you really want to delete this?", "Warning", {
        timeout: 20000,
        close: false,
        overlay: true,
        displayMode: "once",
        position: "center",
        buttons: [
          [
            "<button><b>Yes</b></button>",
            (instance, toast) => {
              axios
                .delete(`/api/qtakedepartment/${data.item.id}`)
                .then((res) => {
                  this.qtake_departmentItems.splice(data.index, 1);
                  this.$toast.success("Delete successfully", "Success", {timeout: 3000});
                })
                .catch((err) => {this.$toast.error(err.response.data, "Error", {timeout: 3000});});
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
            true,
          ],
          [
            "<button>No</button>",
            function (instance, toast) {
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
          ],
        ],
      });
    },
  },
}
</script>